import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from './safeHtml.pipe';

const PIPES = [
    SafeHtmlPipe
];

@NgModule({
  declarations: [...PIPES],
  exports: [...PIPES],
})
export class PipeModule {    
}
